// extracted by mini-css-extract-plugin
export default {"Loading":"Loading_Loading__6KY-H","Loading__Icon":"Loading_Loading__Icon__gqSXh","Loading__Text":"Loading_Loading__Text__IKXj3"};